import React, { useState, useEffect } from 'react';
import { Table, Button } from 'react-bootstrap';
import TablePaginationBar from '../components/TablePaginationBar';
import { BsThreeDots } from 'react-icons/bs';
import { useData } from '../context/DataContext';
import useFetchData from '../hooks/useFetchData';
import { config } from '../config/config';
import { getmembershipPlan } from '../config/url';
import formatDate from '../utils/formatDate';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const Memberships = () => {
  // const { sampleMemberships } = useData();
  const [render, setRender] = useState(null);
  const [currentMemberships, setCurrentMemberships] = useState(null);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('');
  const [memberships, setMemberships] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [membershipsPerPage] = useState(7);

  const sampleMemberships = useFetchData(getmembershipPlan, config);

  useEffect(() => {
    if (sampleMemberships) {
      let filteredMemberships = sampleMemberships;

      if (filter === 'Sort by Price') {
        filteredMemberships = sampleMemberships.sort(
          (a, b) => b.price - a.price
        );
      } else if (filter === 'Sort by Creation Date') {
        filteredMemberships = sampleMemberships.sort(
          (a, b) => {
            const dateA = new Date(a.creationDate);
            const dateB = new Date(b.creationDate);
            return dateA - dateB;
            // return a.creationDate > b.creationDate ? 1 : -1;
          }
          // b.creationDate - a.creationDate
        );
      }
      if (search) {
        filteredMemberships = filteredMemberships.filter((membership) =>
          Object.values(membership)
            .join(' ')
            .toLowerCase()
            .includes(search.toLowerCase())
        );
      }

      setMemberships(filteredMemberships);
      setRender(Math.floor(Math.random() * 10));
    }
  }, [search, filter, sampleMemberships]);

  useEffect(() => {
    const indexOfLastMembership = currentPage * membershipsPerPage;
    const indexOfFirstMembership = indexOfLastMembership - membershipsPerPage;
    setCurrentMemberships(
      memberships.slice(indexOfFirstMembership, indexOfLastMembership)
    );
  }, [render]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const navigate = useNavigate();

  return (
    <div className='container p-2 my-4'>
      <h4 className='mb-3'>Memberships</h4>
      <div className='d-flex justify-content-between align-items-center mb-3'>
        <div>
          <Link to='/membership/addmembership'>
            <Button varient={'primary'}>Add Membership</Button>
          </Link>
        </div>
        {sampleMemberships != null ? (
          <div className='d-flex'>
            <div className='me-2'>
              <input
                type='text'
                className='form-control rounded'
                placeholder='Search by plan'
                style={{ maxWidth: '300px' }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div>
              <select
                className='form-select'
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              >
                <option value=''>Select Filter</option>
                <option value='Sort by Price'>Sort by Price</option>
                <option value='Sort by Creation Date'>
                  Sort by Creation Date
                </option>
              </select>
            </div>
          </div>
        ) : null}
      </div>
      {sampleMemberships != null ? (
        <Table
          className='table bg-white rounded'
          responsive='xl'
          striped
          bordered
          hover
        >
          <thead>
            <tr>
              <th>Plan</th>
              <th>Price</th>
              <th>Connect Hours</th>
              <th>Validity Days</th>
              <th>Type</th>
              <th>Creation Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentMemberships.map((membership) => (
              <tr key={membership._id}>
                <td>{membership.plan}</td>
                <td>{membership.price}</td>
                <td>{membership.connectHours}</td>
                <td>{membership.validityDays}</td>
                <td>{membership.membershipType}</td>
                <td>{formatDate(membership.creationDate)}</td>
                <td>
                  <Button variant='secondary' size='md'>
                    <BsThreeDots
                      onClick={() => {
                        navigate(`/membership/${membership._id}`, {
                          state: membership,
                        });
                      }}
                    />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <h4 className='h4 mt-4 mb-4'>Fetching data...</h4>
      )}
      <TablePaginationBar
        currentPage={currentPage}
        totalItems={memberships.length}
        rowsPerPage={membershipsPerPage}
        onPageChange={paginate}
      />
    </div>
  );
};

export default Memberships;
